/* eslint-disable no-async-promise-executor */
import globalData from '@kk-activity-factory/global-data';
import dialogController from '@kk/vue-dialog';
import { post, getHost, getGS, globalInstance } from '@kk-activity-factory/utils';
import login from '@kk-activity-factory/login';
import toast from '@kk/toast';
import { query } from '@kk/utils';

const HOST = getHost();

function assistRequest(traceCode: string, sign: string) {
    return post({
        url: `${HOST}/gamecard/v2/assistance/join?answer=${sign}`,
        data: {
            traceCode,
        },
    });
}

function assist(assistTraceCode: string, assistanceActivityId: string) {
    return new Promise<void>(async (resolve) => {
        try {
            const sign = await getGS(assistanceActivityId);
            const res = await assistRequest(assistTraceCode, sign);
            if (res.code !== 200) {
                throw res;
            }

            dialogController.asyncShow({
                component: () =>
                    import(/* webpackChunkName: "assist-result" */ './components/AssistResult.vue'),
                props: {
                    withCloseBtn: false,
                },
                contentProps: {
                    assistanceActivityId,
                    assistantPrize: res.data.assistantPrize,
                    inviterUid: res.data.inviterUid,
                    inviterPrize: res.data.inviterPrize,
                    assistName: res.data.assistanceActivityName,
                },
                events: {
                    afterLeave: () => {
                        resolve();
                    },
                },
            });
        } catch (error) {
            console.error('assist', error);
            if (error instanceof Error) {
                toast.show(error.message);
            }
            resolve();
        }
    });
}

// 根据url参数进行助力
function assistHandler() {
    return new Promise<void>(async (resolve) => {
        const assistTraceCode = query.get('assistTraceCode');
        const assistanceActivityId = query.get('assistanceActivityId');
        const store = globalInstance.getRootStore();
        if (!assistTraceCode) {
            resolve();
            return;
        }

        const urlParam = {
            assistTraceCode,
            assistanceActivityId,
        };

        if (globalData.isOutside) {
            // 如果有助力码 且在端外 弹出引导到端内助力窗口
            dialogController.asyncShow({
                component: () =>
                    import(
                        /* webpackChunkName: "outside-assist" */ './components/OutsideAssist.vue'
                    ),
                props: {
                    withCloseBtn: false,
                },
                contentProps: {
                    urlParam,
                },
                events: {
                    afterLeave: () => {
                        resolve();
                    },
                },
            });
        } else {
            // 在端内 则进行助力
            if (store.state.user.uid) {
                await assist(assistTraceCode, assistanceActivityId);
                resolve();
                return;
            }
            login({
                // 使用半屏登录
                type: 1,
                title: store.getters.title,
                callback: (res: { data: { path_step: number; is_success_login: boolean } }) => {
                    const { path_step, is_success_login } = res.data;
                    if (path_step) {
                        if (is_success_login) {
                            // 安卓url中带有hash值，可能会导致 location.reload 失效，故要去除 hash 值
                            location.replace(location.href.split('#')[0]);
                            return;
                        } else {
                            resolve();
                            return;
                        }
                    }
                },
            });
        }
    });
}

function canAssist(): boolean {
    const assistTraceCode = query.get('assistTraceCode');
    const assistanceActivityId = query.get('assistanceActivityId');
    return assistTraceCode && assistanceActivityId;
}

export { assistHandler, canAssist };
